module.exports = __webpack_public_path__ + "img/9788960178359.47dafc7a.jpg";